import styled, { css } from 'styled-components';
import { getSizeBy, getFontFamily, getTypography, getThemePropOrElse } from '../../../src/styled/utils';
import mixins from './mixins';
/**
 * Styled component for a level 2 heading (h2).
 *
 * @component
 *
 * @example
 * // Render the component with default styles.
 * <Heading2>Hello, world!</Heading2>
 *
 * @example
 * // Render the component with custom styles.
 * <Heading2 style={{ color: 'red' }}>Hello, world!</Heading2>
 *
 * @param {object} props - Component props.
 * @param {string} props.children - The content to display inside the heading.
 * @param {object} [props.style] - Optional custom styles.
 *
 * @returns {React.ElementType} The rendered Heading2 component.
 */
export const Heading2Styles = css `
  font-weight: ${getThemePropOrElse(['typography', 'Heading2', 'fontWeight'], 600)};
  font-size: ${getThemePropOrElse(['typography', 'Heading2', 'fontSize'], getSizeBy(5.5))};
  font-family: ${getFontFamily('secondary')};
  line-height: ${getSizeBy(6)};
  letter-spacing: ${getSizeBy(-0.02)};
`;
const TextElement = styled.h2 `
  ${mixins}
  ${Heading2Styles}
`;
export const Heading2 = styled(TextElement)({}, ({ theme }) => getTypography('Heading2')({ theme }));
